import script from "./ModalConfirmAddToGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalConfirmAddToGroup.vue?vue&type=script&lang=ts&setup=true"

import "./ModalConfirmAddToGroup.vue?vue&type=style&index=0&id=1080c5b1&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1080c5b1"]])

export default __exports__